import { configApiRef, useApi } from '@backstage/core-plugin-api';

export function usePremiumUi(): boolean {
  const configApi = useApi(configApiRef) as { getOptionalBoolean?: (key: string) => boolean | undefined };
  if (typeof configApi?.getOptionalBoolean !== 'function') {
    return true;
  }
  return configApi.getOptionalBoolean('premiumUi.enabled') ?? true;
}
